import constants from '@/app-configs/constants'

export default [
  {
    path: '/api-tokens',
    name: 'api-tokens',
    component: () => import('@/views/apitokens/ApiTokens.vue'),
    meta: {
      pageTitle: 'DEBTIA_API_TOKENS',
      breadcrumb: [
        {
          text: 'DEBTIA_API_TOKENS',
          active: true,
        },
      ],
      action: constants.action.permissionApiTokenList,
      resource: constants.resource.apiToken,
    },
  },
]
